/*
 * @Descripttion: 请求错误码表
 * @Author: juanjuanhui
 * @Date: 2022-03-25 18:51:16
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-08-09 21:57:44
 */
export const errCodeData = [
  {
    code: 9000000006,
    msg: "该流转合同下已有订单，请先删除全部订单!",
  },
  {
    code: 8000000023,
    msg: "该经营主体已经注册，无需重复注册，请检查输入内容，若有疑问可联系工作人员咨询。",
  },
  {
    code: 8000000049,
    msg: "未完成服务主体申请",
  },
];
